var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"auth-form-title"},[_c('div',{staticClass:"auth-form-title__title-wrapper"},[_c('h2',{staticClass:"auth-form-title__title"},[_vm._v(_vm._s(_vm.titleText.toUpperCase()))])])])}
var staticRenderFns = []

export { render, staticRenderFns }